/** Colecciones Firestore compartidas con Bordona (no duplicar rutas). */
export const STUDENT_PROFILES_COLLECTION = 'bordona_student_profiles';
export const USER_SONGS_COLLECTION = 'userSongs';
export const CLASSROOMS_COLLECTION = 'bordona_classrooms';
export const CLASSROOM_MEMBERS_COLLECTION = 'bordona_classroom_members';

export const PLAY_STUDENT_PROFILE_STORAGE = 'play-student-profile';
